import {
  Box,
  File,
  FileArchive,
  FileBox,
  FileCode2,
  FileImage,
  FileJson,
  FileSpreadsheet,
  FileText,
  LucideProps,
  NotebookPen,
} from "lucide-react";
import React from "react";

import { is3DLikeExtension, modelTypes } from "../utils/modelTypes";

interface FileTypeIconProps extends LucideProps {
  extension?: string;
}

const spreadsheetExtensions = new Set(["xlsx", "xlst", "xls"]);
const modelFileExtensions = new Set([
  "mdzip",
  "mdxml",
  "slx",
  "mat",
  "fig",
  "sysml",
  "stp",
  "step",
  "stl",
  "prt",
  "asm",
  "catpart",
  "catproduct",
]);
const archiveExtensions = new Set(["zip", "rar", "7z", "tar", "gz", "bz2"]);

export const getFileTypeIcon = (extension?: string) => {
  if (!extension) return File;

  const normalizedExtension = extension.toLowerCase();
  const modelType = modelTypes[normalizedExtension as keyof typeof modelTypes];

  if (normalizedExtension === "ipynb") return NotebookPen;
  if (is3DLikeExtension(normalizedExtension)) return Box;
  if (spreadsheetExtensions.has(normalizedExtension)) return FileSpreadsheet;
  if (modelFileExtensions.has(normalizedExtension)) return FileBox;
  if (archiveExtensions.has(normalizedExtension)) return FileArchive;
  if (!modelType) return File;
  switch (modelType.type) {
    case "3dviewer":
      return FileBox;
    case "image":
      return FileImage;
    case "pdf":
      return FileText;
    case "text":
      if (normalizedExtension === "csv") return FileSpreadsheet;
      if (normalizedExtension === "json") return FileJson;
      return FileCode2;
    default:
      return File;
  }
};

export const FileTypeIcon: React.FC<FileTypeIconProps> = ({ extension, ...props }) => {
  const Icon = getFileTypeIcon(extension);
  return <Icon {...props} />;
};
